/**
 * The app's content shell, declared once in `App.tsx`.
 *
 * It fills the iframe through `min-height: 100vh` but grows naturally with route
 * content so `useIframeAutoResize` can report the complete required height.
 */
export const APP_SCROLL_CONTAINER_ID = "app-scroll-container";
